import React from "react";
import { Payment, StripeForm } from "./interface";
import { SubmitHandler, useForm } from "react-hook-form";
import { API_ROUTES } from "@/services/environment";
import useLoading from "@/hooks/useLoading";
import { useAppSelector } from "@/hooks/hook";
import Alert from "@/components/alert/Alert";
import { POST } from "@/services/api";
import { Button } from "@thdinc/hpf-shared";

interface StripeCompForm {
  paymentInfo: Payment;
  closeModal: () => void;
  renderFun: () => void;
}
const StripeBTCForm: React.FC<StripeCompForm> = ({
  paymentInfo,
  closeModal,
  renderFun,
}) => {
  const {
    register,
    handleSubmit,
    reset,
    setValue,
    formState: { errors, isValid },
  } = useForm<StripeForm>();

  const { postPaymentApi } = API_ROUTES;
  const { isLoading, startLoading, stopLoading } = useLoading();
  const { refreshToken } = useAppSelector((store) => store.user);
  const onSubmit: SubmitHandler<StripeForm> = async (data) => {
    startLoading();
    try {
      const res = await POST(
        postPaymentApi,
        {
          ...data,
          HOWS: false,
          business_id: paymentInfo.business_id,
          booking_id: paymentInfo.id,
        },
        refreshToken
      );

      if (res.data) {
        if (res.data.success) {
          renderFun();
          closeModal();

          reset({
            amount: 0,
            description: "",
            platform_fee: 0,
          });
          Alert({ message: res?.data?.message });
        }
      }
    } catch (error) {
      Alert({ type: "error", message: "Something went wrong" });
    } finally {
      stopLoading();
    }
  };
  return (
    <div>
      <form onSubmit={handleSubmit(onSubmit)}>
        <p className="ml-4 mb-3 text-xl">
          Business :{" "}
          <span className="text-gray-500">{paymentInfo.business_name}</span>
        </p>
        <div className=" flex gap-8 ">
          <div className=" w-full">
            <p className="font-semibold  text-xs mb-2 ml-4 ">Amount Charged</p>
            <input
              step=".01"
              type="number"
              maxLength={21}
              className="w-full px-4 py-3 bg-p-gray rounded-full    focus:outline-none  focus:ring-1 focus:ring-primary-red text-gray-600"
              placeholder={"Enter Amount"}
              {...register("amount", {
                required: "Amount is required",
              })}
            />
            <p className="text-red-500 text-xs mb-2 mt-1 ml-4">
              {errors?.amount?.message}
            </p>
          </div>
          <div className="w-full">
            <p className="font-semibold  text-xs mb-2 ml-4 ">Platform Fee</p>

            <input
              step=".01"
              type="number"
              maxLength={21}
              className="w-full px-4 py-3 bg-p-gray rounded-full    focus:outline-none  focus:ring-1 focus:ring-primary-red text-gray-600"
              placeholder={"Enter Amount"}
              {...register("platform_fee", {
                required: "Platform Fee is required",
              })}
            />
            <p className="text-red-500 text-xs mb-2 mt-1 ml-4">
              {errors?.platform_fee?.message}
            </p>
          </div>
        </div>
        <div className="mt-8">
          <div className="w-full">
            <p className="font-semibold  text-xs mb-2 ml-4 "> Description</p>
            <textarea
              rows={5}
              {...register("description", {
                required: "Description is required",
              })}
              className="w-full px-4 py-3 bg-p-gray rounded-2xl    focus:outline-none  focus:ring-1 focus:ring-primary-red text-gray-600"
            />
            <p className="text-red-500 text-xs mb-2 mt-1 ml-4">
              {errors?.description?.message}
            </p>
          </div>
        </div>
        <div className="text-end">
          <Button
            disabled={isLoading}
            className={`text-center  px-6  mt-5   rounded-full py-2 ${
              isValid
                ? "bg-primary-red hover:bg-primary-red-button-hover text-white"
                : "bg-gray-300 text-gray-500  "
            } `}
          >
            {isLoading ? "Processing..." : "Charge"}
          </Button>
        </div>
      </form>
    </div>
  );
};

export default StripeBTCForm;
